import { useEffect, useState } from 'react'
import { getApiUrl } from '../utils/api'

// { env: 'production' | 'staging', readOnly } from the API, fetched once.
let cached = null
let inflight = null

export function useAppEnv() {
  const [env, setEnv] = useState(cached || { env: 'production', readOnly: false })
  useEffect(() => {
    if (cached) return
    inflight = inflight || fetch(getApiUrl('/api/env')).then((r) => (r.ok ? r.json() : null)).catch(() => null)
    inflight.then((d) => { if (d) { cached = d; setEnv(d) } })
  }, [])
  return env
}
